// @ts-check
import { Link } from 'react-router-dom'
import { checkProSearchPath, currentPath, re } from '../../helpers/checkProSearchPath'
import styles from './SearchHints.module.css'

/** @typedef {{ onClear?: () => void }} Props */
/** @param {Props} props */
export default function SearchHints({ onClear }) {
  return (
    <div className={styles.overlayContent}>
      <div className={styles.searchTips}>
        Tip: You can search by name or role (photographer, model, etc.)
      </div>
      <div className={styles.overlaySection}>
        <div className={styles.searchOverlayHeader}>
          <div className={styles.title}>Models.com ProSearch</div>
          {checkProSearchPath(re, currentPath) ? (
            <Link to={`/search/all`} onClick={onClear ?? undefined}>
              See all roles
            </Link>
          ) : (
            <a href="/search/all">See all roles</a>
          )}
        </div>
        <div className={styles.sectionLinks}>
          {checkProSearchPath(re, currentPath) ? (
            <Link to={`/search/model`} onClick={onClear ?? undefined}>
              Models
            </Link>
          ) : (
            <a href="/search/model">Models</a>
          )}
          {checkProSearchPath(re, currentPath) ? (
            <Link to={`/search/photographer`} onClick={onClear ?? undefined}>
              Photographers
            </Link>
          ) : (
            <a href="/search/photographer">Photographers</a>
          )}
          {checkProSearchPath(re, currentPath) ? (
            <Link to={`/search/fashion-editor-stylist`} onClick={onClear ?? undefined}>
              Fashion Editors/Stylists
            </Link>
          ) : (
            <a href="/search/fashion-editor-stylist">Fashion Editors/Stylists</a>
          )}
          {checkProSearchPath(re, currentPath) ? (
            <Link to={`/search/makeup-artist`} onClick={onClear ?? undefined}>
              Makeup Artists
            </Link>
          ) : (
            <a href="/search/makeup-artist">Makeup Artists</a>
          )}
        </div>
      </div>
      <div className={styles.overlaySection}>
        <div className={styles.title}>Agencies and companies</div>
        <div className={styles.overlayLinkList}>
          <a href="/agencies/">Modeling Agencies</a>
          <a href="/agencies/PhotoRep">Artist Agencies</a>
          <a href="/agencies/Production">Production &amp; Creative Services</a>
        </div>
      </div>
    </div>
  )
}
